import React from 'react';
import { CheckboxInput } from './CheckboxInput.styles';
import { ReactComponent as Checked } from '../../../assets/icons/checked-icon.svg';
import { ReactComponent as Unchecked } from '../../../assets/icons/unchecked-icon.svg';

const CheckedInput = ({ checked, onClick, label }) => {
  return (
    <CheckboxInput onClick={onClick}>
      {label} {checked ? <Checked style={{ marginRight: 2 }} /> : <Unchecked />}
    </CheckboxInput>
  );
};

export default CheckedInput;
